/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateBookingRequestDto
 */
export interface CreateBookingRequestDto {
    /**
     * Уникальный идентификатор по которому можно понять для какого заказа создаётся бронь
     * @type {string}
     * @memberof CreateBookingRequestDto
     */
    idempKey: string;
}

/**
 * Check if a given object implements the CreateBookingRequestDto interface.
 */
export function instanceOfCreateBookingRequestDto(value: object): value is CreateBookingRequestDto {
    if (!('idempKey' in value) || value['idempKey'] === undefined) return false;
    return true;
}

export function CreateBookingRequestDtoFromJSON(json: any): CreateBookingRequestDto {
    return CreateBookingRequestDtoFromJSONTyped(json, false);
}

export function CreateBookingRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBookingRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'idempKey': json['idempKey'],
    };
}

  export function CreateBookingRequestDtoToJSON(json: any): CreateBookingRequestDto {
      return CreateBookingRequestDtoToJSONTyped(json, false);
  }

  export function CreateBookingRequestDtoToJSONTyped(value?: CreateBookingRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idempKey': value['idempKey'],
    };
}

